import { Injectable } from "@angular/core";
import { Observable, from, scheduled } from "rxjs";
import { environment } from "src/environments/environment";
import { BaseService } from "../base.service";
import { tap, catchError } from "rxjs/operators";
import { User } from "src/app/models/user";
import { CookieService } from "ngx-cookie-service";
import { Router } from "@angular/router";
import { HttpHeaders } from "@angular/common/http";
import { async } from "@angular/core/testing";

@Injectable({
  providedIn: "root",
})
export class AuthenticateService {
  private res;
  public user: User;
  public token: AuthToken;
  cookieName = "auth_token";
  domainKeyName = "domain";
  domain = "zyla.in";

  constructor(
    public baseService: BaseService,
    public cookieService: CookieService,
    public router: Router
  ) {}

  setOtpResponse(res) {
    this.res = res;
  }
  getOtpResponse() {
    return this.res;
  }

  validateOtp(query): Observable<any> {
    const url = `${environment.apiURL}/login/v5/otp`;
    return this.baseService.post(url, query).pipe(
      tap(async (res) => {
        return res;
      }),
      catchError((e) => {
        throw e;
      })
    );
  }

  getOTP(phoneNo: string): Observable<AuthResponse> {
    const url = `${environment.apiURL}/login/v2/otp?phoneNo=${phoneNo}&countrycode=91&referrerUrl=null&deepLinks=null`;
    return this.baseService.get(url).pipe(
      tap(async (res: AuthResponse) => {
        if (res) {
          this.baseService.storage.set(`${environment.name}.profile`, res.user);
          this.user = res.user;
        }
      }),
      catchError((e) => {
        console.log(e);
        throw e;
      })
    );
  }

  autoLogin(phoneNo: string, token: AuthToken, user: User) {
    if (!user) {
      const url = `${environment.apiURL}/login/authorize?phoneNo=${phoneNo}`;
      const httpHeader = new HttpHeaders()
        .set("Authorization", `Bearer ${token}`)
        .set("phone_no", phoneNo);
      this.user = null;
      this.clearUserDetail().subscribe((res) => {});

      return new Observable((observer) => {
        this.baseService
          .getWithHeader(url, httpHeader)
          .pipe(
            tap(async (res: AuthResponse) => {
              // if (res) {
              //   console.log("response from user authorisation api is ", res);
              // this.cookieService.set("phone_no", `${res.user.phoneNo}`);
              // this.cookieService.set("auth_token", `${res.user.authToken}`);
              // this.cookieService.set("client", `patient_android`);
              //   this.token = token;
              //   this.cookieService.set(
              //     "phone_no",
              //     `${res.user.phoneNo}`,
              //     -1,
              //     "/",
              //     ".abhi.zyla.in"
              //   );
              //   this.cookieService.set(
              //     "auth_token",
              //     `${res.user.authToken}`,
              //     -1,
              //     "/",
              //     ".abhi.zyla.in"
              //   );
              //   this.cookieService.set(
              //     "client",
              //     `patient_android`,
              //     -1,
              //     "/",
              //     ".abhi.zyla.in"
              //   );
              //   localStorage.setItem(
              //     `${environment.name}.profile`,
              //     JSON.stringify(res.user)
              //   );
              //   localStorage.setItem(
              //     `${environment.name}.token`,
              //     JSON.stringify(token)
              //   );
              //   this.baseService.storage.set(
              //     `${environment.name}.profile`,
              //     res.user
              //   );
              //   this.user = res.user;
              //   observer.next(res.user);
              // }
            }),
            catchError((e) => {
              console.log(e);

              throw e;
            })
          )
          .subscribe((res) => {
            this.token = token;
            this.setUserLoggedIn(phoneNo, res.token, res.user);
            observer.next(res.user);
          });
      });
    } else {
      this.token = token;

      this.setUserLoggedIn(phoneNo, token, user);

      return new Observable<any>((observer) => {
        observer.next(user);
      });
    }
    // return this.setupToken(token.accessToken, token.expiryToken);
    // const url = `${environment.apiURL}/login/authorize?phoneNo=${phoneNo}`;
    // const httpHeader = new HttpHeaders()
    //   .set("Authorization", `Bearer ${auth_token}`)
    //   .set("phone_no", phoneNo);
    // this.user = null;
    // this.clearUserDetail().subscribe((res) => {});

    // return this.baseService.getWithHeader(url, httpHeader).pipe(
    //   tap(async (res: AuthResponse) => {
    //     if (res) {
    // this.cookieService.set("phone_no", `${res.user.phoneNo}`);
    // this.cookieService.set("auth_token", `${res.user.authToken}`);
    // this.cookieService.set("client", `patient_android`);
    // this.token = token;
    // this.cookieService.set(
    //   "phone_no",
    //   `${res.user.phoneNo}`,
    //   -1,
    //   "/",
    //   ".abhi.zyla.in"
    // );
    // this.cookieService.set(
    //   "auth_token",
    //   `${res.user.authToken}`,
    //   -1,
    //   "/",
    //   ".abhi.zyla.in"
    // );
    // this.cookieService.set(
    //   "client",
    //   `patient_android`,
    //   -1,
    //   "/",
    //   ".abhi.zyla.in"
    // );
    // localStorage.setItem(
    //   `${environment.name}.profile`,
    //   JSON.stringify(res.user)
    // );
    // localStorage.setItem(
    //   `${environment.name}.token`,
    //   JSON.stringify(token)
    // );

    // this.baseService.storage.set(`${environment.name}.profile`, res.user);

    //       this.setupToken(token.accessToken, token.expiryToken);
    //     }
    //   }),
    //   catchError((e) => {
    //     console.log(e);
    //     this.router.navigateByUrl("/session-expired");
    //     throw e;
    //   })
    // );
  }
  setUserLoggedIn(phoneNo, token, user) {
    this.cookieService.deleteAll("/");
    document.cookie = `phone_no=${phoneNo};path=/;`;
    document.cookie = `auth_token=${token.accessToken};path=/;`;
    document.cookie = `client=patient_android;path=/;`;

    // this.cookieService.set("phone_no", `${phoneNo}`, 1, "/", ".abhi.zyla.in");
    // this.cookieService.set(
    //   "auth_token",
    //   `${token.accessToken}`,
    //   1,
    //   "/",
    //   ".abhi.zyla.in"
    // );
    // this.cookieService.set(
    //   "client",
    //   `patient_android`,
    //   1,
    //   "/",
    //   ".abhi.zyla.in"
    // );
    localStorage.setItem(`${environment.name}.profile`, JSON.stringify(user));
    this.baseService.storage.set(`${environment.name}.profile`, user);

    localStorage.setItem(`${environment.name}.token`, JSON.stringify(token));
    this.user = user;
    this.token = token;

    // this.user = response.user;
  }
  getLoggedInUserDetail(): Observable<User> {
    this.baseService.storage.get(`${environment.name}.profile`).then((res) => {
      this.user = res;
    });

    return from(this.baseService.storage.get(`${environment.name}.profile`));
  }
  clearUserDetail(): Observable<any> {
    return from(this.baseService.storage.remove(`${environment.name}.profile`));
  }
  checkToken() {
    var user = this.getUserProfile();

    if (user !== null) {
      var accessToken = this.getToken(false);
      var expTkn = this.getToken(true).expiryToken;
      if (accessToken !== null) this.setupToken(accessToken, expTkn);
      else {
        var payload = {
          accessToken: "",
          expiryToken: expTkn,
        };
        let url = `${environment.apiURL}/login/token`;

        this.baseService.post(url, payload).pipe(
          tap(async (response) => {
            if (response.accessToken !== null) {
              this.setToken(response);
              this.setSession(response.accessToken, 1051200);
              this.checkToken();
            } else {
              this.router.navigateByUrl("/session-expired");
            }
          }),
          catchError((e) => {
            throw e;
          })
        );
      }
    }
  }
  setupToken(accessToken, expTkn): Observable<any> {
    if (this.isExpired(expTkn)) {
      var payload = {
        accessToken: "",
        expiryToken: expTkn,
      };
      let url = `${environment.apiURL}/login/token`;

      return this.baseService.post(url, payload).pipe(
        tap(async (response) => {
          if (response.accessToken !== null) {
            this.setSession(response.accessToken, 1051200);
            this.setToken(response);
            // this.checkToken();
          } else {
            this.router.navigateByUrl("/session-expired");
          }
        }),
        catchError((e) => {
          this.router.navigateByUrl("/session-expired");
          throw e;
        })
      );
    } else {
      this.setSession(accessToken, 1051200);

      this.router.navigateByUrl("/chat");
    }
  }
  isExpired = (token) => {
    // if (token != null) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    var finalToken = JSON.parse(jsonPayload);

    if (finalToken) {
      const expiry = finalToken.exp;
      const now = new Date();
      return now.getTime() > expiry * 1000;
    }
    return false;
    // } else return true;
  };
  setToken(token) {
    localStorage.setItem("zy.ACCESS_TOKEN", JSON.stringify(token));

    sessionStorage.setItem("auth_token", token.accessToken);
  }
  getToken(status) {
    if (status) {
      return JSON.parse(localStorage.getItem("zy.ACCESS_TOKEN"));
    } else {
      return sessionStorage.getItem("auth_token");
    }
    //         token:
    // accessToken:
    // expiryToken:
  }
  setSession(token, minutes) {
    var expires = "";
    if (minutes) {
      let date = new Date(0);
      if (minutes > 0) {
        date = new Date();
        date.setTime(date.getTime() + minutes * 60 * 1000);
      }
      expires = "; expires=" + date.toUTCString();
    }
    var domain = "";
    if (this.domain) {
      domain = "; " + this.domainKeyName + "=" + this.domain;
    }

    document.cookie =
      this.cookieName + "=" + token + "; path=/;" + expires + domain;
  }
  getUserProfile() {
    return JSON.parse(localStorage.getItem(`${environment.name}.profile`));
  }
}

export interface AuthResponse {
  token: {
    accessToken: string;
    expiryToken: string;
  };
  user: User;
}

export interface AuthToken {
  accessToken: string;
  expiryToken: string;
}
